import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AnimatedSection } from "@/components/AnimatedSection";

const ServicePlans = () => {
  const plans = [
    {
      name: "PLAN BÁSICO",
      price: "$49.990",
      icon: "📋",
      features: [
        "Levantamiento técnico completo",
        "Revisión visual de tableros",
        "Medición de consumos",
        "Informe técnico con recomendaciones",
        "Cotización de mantención (sin costo)"
      ],
      popular: false
    },
    {
      name: "PLAN MANTENCIÓN",
      price: "$129.990",
      icon: "🔧",
      features: [
        "Todo lo del Plan Básico",
        "Limpieza de tableros eléctricos",
        "Ajuste de conexiones",
        "Revisión de protecciones (diferenciales, térmicas)",
        "Pruebas de continuidad",
        "Certificado de mantención"
      ],
      popular: true
    },
    {
      name: "PLAN NORMALIZACIÓN",
      price: "Desde $249.990",
      icon: "⚡",
      features: [
        "Todo lo del Plan Mantención",
        "Reemplazo de componentes defectuosos",
        "Actualización de protecciones",
        "Instalación de nuevos circuitos (si necesario)",
        "Documentación técnica SEC",
        "Certificado SEC (si aplica)"
      ],
      popular: false
    }
  ];

  const scrollToForm = () => {
    const formSection = document.getElementById('formulario');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="planes" className="relative py-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-dark-section via-industrial-gray/95 to-dark-section/90">
        <div className="absolute top-20 left-10 w-96 h-96 bg-primary/20 rounded-full blur-3xl animate-liquid-blob opacity-20" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/15 rounded-full blur-3xl animate-liquid-blob-delayed opacity-20" />
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <AnimatedSection animation="fade-in">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-white text-center mb-4">
            ¿Qué Incluye el Servicio?
          </h2>
          <p className="text-lg text-white/70 text-center mb-12 max-w-2xl mx-auto">
            Elige el plan que mejor se adapte a las necesidades de tu local comercial
          </p>
        </AnimatedSection>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 lg:gap-10 max-w-7xl mx-auto mb-12 mt-8">
          {plans.map((plan, index) => (
            <AnimatedSection
              key={index}
              animation="slide-up"
              delay={index * 100}
            >
              <div className={`relative backdrop-blur-xl bg-white/10 border-2 ${plan.popular ? 'border-primary/60 scale-105' : 'border-white/20'} rounded-3xl p-8 hover:bg-white/15 transition-all duration-300 hover:scale-105 h-full flex flex-col`}>
                {plan.popular && (
                  <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-primary text-white px-6 py-2 rounded-full text-sm font-bold shadow-liquid-lg z-10">
                    MÁS POPULAR
                  </div>
                )}
                
                <div className="text-center mb-6">
                  <div className="text-5xl mb-4">{plan.icon}</div>
                  <h3 className="text-2xl font-montserrat font-bold text-white mb-3">
                    {plan.name}
                  </h3>
                  <p className="text-3xl font-bold text-primary">{plan.price}</p>
                </div>

                <ul className="space-y-3 mb-8 flex-grow">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <Check className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                      <span className="text-white/90 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  onClick={scrollToForm}
                  className={`w-full ${plan.popular ? 'glass-liquid-medium bg-primary/90 hover:bg-primary' : 'glass-liquid-light hover:bg-white/20'} text-white`}
                >
                  Solicitar Cotización
                </Button>
              </div>
            </AnimatedSection>
          ))}
        </div>

        <AnimatedSection animation="fade-in" delay={300}>
          <p className="text-center text-white/60 text-sm">
            *Precios referenciales. Cotización final según tamaño del local y cantidad de equipos.
          </p>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default ServicePlans;
